import { IQueryContext } from 'framework/context/IQueryContext';
import { IAgendaQueryParams, IAgendaResponse } from 'gen/ApiClient';
import React from 'react';

export const AgendaQueryContext = React.createContext<IQueryContext<IAgendaResponse, IAgendaQueryParams>>(undefined as any);
